// Dados da empresa. Tudo em leitura, menos o telefone: boa parte do cadastro
// veio da sincronização sem telefone, e a tela só mostrava "Não informado" sem
// deixar o fornecedor corrigir. Ele é pedido aqui porque a OC e a FACITE
// precisam de um contato.

import React from "react";
import { HiOfficeBuilding } from "react-icons/hi";
import { FornecedorInfo } from "../../../types/orcamento-fornecedor.types";
import {
  formatCNPJ,
  formatTelefone,
} from "../../../utils/orcamento-formatters";

interface DadosEmpresaProps {
  fornecedor: FornecedorInfo;
  telefone: string;
  onTelefoneChange: (valor: string) => void;
  erro?: string;
  mostrarErro?: boolean;
}

export const DadosEmpresa: React.FC<DadosEmpresaProps> = ({
  fornecedor,
  telefone,
  onTelefoneChange,
  erro,
  mostrarErro = false,
}) => {
  const invalido = mostrarErro && !!erro;
  return (
    <div className="border-b border-gray-200 pb-6">
      <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-200">
        <div className="w-10 h-10 rounded-lg bg-[#4760e0]/10 flex items-center justify-center">
          <HiOfficeBuilding className="h-6 w-6 text-[#4760e0]" />
        </div>
        <h2 className="text-xl font-bold text-[#161519]">
          Dados da sua empresa
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">
            {fornecedor.nome ? "Nome Fantasia" : "Razão Social"}
          </label>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
            <span className="font-medium text-[#161519]">
              {fornecedor.nome || fornecedor.razaoSocial}
            </span>
          </div>
        </div>

        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">
            CNPJ
          </label>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
            <span className="font-mono text-[#161519]">
              {formatCNPJ(fornecedor.cnpj)}
            </span>
          </div>
        </div>

        {fornecedor.razaoSocial && fornecedor.nome && (
          <div className="md:col-span-2">
            <label className="text-sm font-medium text-gray-600 mb-1 block">
              Razão Social
            </label>
            <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
              <span className="text-[#161519]">{fornecedor.razaoSocial}</span>
            </div>
          </div>
        )}

        <div className="md:col-span-2">
          <label className="text-sm font-medium text-gray-600 mb-1 block">
            Endereço
          </label>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
            <span className="text-[#161519]">
              {fornecedor.endereco || "Não informado"}
            </span>
            {fornecedor.cep && (
              <span className="ml-2 text-sm text-gray-500">
                CEP: {fornecedor.cep}
              </span>
            )}
          </div>
        </div>

        <div>
          <label
            className="text-sm font-medium text-gray-600 mb-1 block"
            htmlFor="telefone-empresa"
          >
            Telefone <span className="text-red-500">*</span>
          </label>
          <input
            id="telefone-empresa"
            type="tel"
            inputMode="tel"
            value={formatTelefone(telefone)}
            onChange={(e) => onTelefoneChange(e.target.value)}
            placeholder="(00) 00000-0000"
            className={`w-full p-3 rounded-lg border text-[#161519] focus:outline-none focus:ring-2 focus:ring-[#4760e0]/40 ${
              invalido ? "border-red-500 bg-red-50" : "border-gray-200 bg-white"
            }`}
          />
          {invalido && <p className="mt-1 text-sm text-red-600">{erro}</p>}
        </div>

        {/*  <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">
            Email
          </label>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
            <span className="text-[#161519]">
              {fornecedor.email || "Não informado"}
            </span>
          </div>
        </div> */}
      </div>
    </div>
  );
};
